"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _UTF8Encoder = _interopRequireDefault(require("./UTF8Encoder"));

var _sha256Hasher = _interopRequireDefault(require("./sha256Hasher"));

// based on https://developer.okta.com/blog/2019/05/01/is-the-oauth-implicit-flow-dead
// Calculate the SHA256 hash of the input text.
// Returns a promise that resolves to an ArrayBuffer
var sha256 = function sha256(plain) {
  var encoder = new _UTF8Encoder.default();
  var data = encoder.encode(plain);
  return (0, _sha256Hasher.default)(data);
};

var base64urlEncode = function base64urlEncode(str) {
  // Convert the ArrayBuffer to string using Uint8 array to convert to what btoa accepts.
  // btoa accepts chars only within ascii 0-255 and base64 encodes them.
  // Then convert the base64 encoded to base64url encoded
  //   (replace + with -, replace / with _, trim trailing =)
  return btoa(String.fromCharCode.apply(null, new Uint8Array(str))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}; // Return the base64-urlencoded sha256 hash for the PKCE challenge


var pkceChallengeFromVerifier = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(v) {
    var hashed;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return sha256(v);

          case 2:
            hashed = _context.sent;
            return _context.abrupt("return", base64urlEncode(hashed));

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function pkceChallengeFromVerifier(_x) {
    return _ref.apply(this, arguments);
  };
}();

var _default = pkceChallengeFromVerifier;
exports.default = _default;